import { ChildrenItem } from "dependencies/base"
import { DataGrid } from "./model"
import { home, bs, appHome } from "./diffrence_options"
// let icon = "icon-portal-icon_row"
let icon = "icon-portal-free_layout"  // 产品提议改成和自由布局一样

export let dataGrid_children = []
export let bigScreen_dataGrid_children = []
export let login_children = []
export let app_dataGrid_children = []
for (let i = 0; i < home.length; i++) {
  dataGrid_children.push(new ChildrenItem("列表页数据样式" + i, icon, "cxDataGrid", new DataGrid(home[i])))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_dataGrid_children.push(new ChildrenItem("列表页数据样式" + i, icon, "cxDataGrid", new DataGrid(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_dataGrid_children.push(new ChildrenItem("列表页数据样式" + i, icon, "cxDataGrid", new DataGrid(appHome[i])))
}
